import { Stack } from "@altimateai/lego";
import { Button, Card, CardContent, Typography } from "@altimateai/lego";
import { IconFileText, IconPuzzle } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { dropdownMenuData, PathOption, pathConfigs } from "../../constants";
import Dropdown from "../dropdown/Dropdown";

const datamatesConfig = pathConfigs[PathOption.Datamates];
const datamatesDropdowns = dropdownMenuData[PathOption.Datamates];

function DatamatesSection() {
  return (
    <Card className="al-rounded-xl al-py-8 al-px-4 !al-bg-blue-50">
      <CardContent>
        <Stack direction="column" gap="xl">
          <Stack direction="column">
            <Typography variant="h4" weight="semibold" className="al-text-gray-900">
              Get Started with Datamates
            </Typography>
            <Typography size="sm" className="al-text-gray-600">
              Build custom AI teammates with data tools, memory, and guardrails
            </Typography>
          </Stack>
          <Stack gap="sm" direction="column" className="al-py-2 sm:al-flex-row">
            <Button
              size="lg"
              className="al-bg-slate-900 hover:al-bg-slate-800 al-py-7 al-px-8 al-text-base al-w-full sm:al-w-auto"
              asChild
            >
              <Link
                to="https://datamates-docs.myaltimate.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <IconFileText size={18} />
                View Documentation
              </Link>
            </Button>
            <Button
              size="lg"
              className="al-bg-slate-900 hover:al-bg-slate-800 al-py-7 al-px-8 al-text-base al-w-full sm:al-w-auto"
              asChild
            >
              <Link
                to="https://marketplace.visualstudio.com/items?itemName=altimateai.vscode-altimate-mcp-server"
                target="_blank"
                rel="noopener noreferrer"
              >
                <IconPuzzle size={18} />
                Install Extension
              </Link>
            </Button>
          </Stack>
          <Stack direction="column" gap="md" className="al-space-y-2">
            {datamatesDropdowns.map((item, index) => (
              <Dropdown
                key={item.title}
                stepNumber={String(index + 1)}
                title={item.title}
                subtitle={item.subtitle}
                tutorial={item.tutorial}
                borderColor={datamatesConfig.borderColor}
                bgColor={datamatesConfig.bgColor}
              />
            ))}
          </Stack>
          <Stack
            direction="column"
            align="center"
            justify="between"
            className="al-w-full al-pt-10 al-border-t al-border-gray-200 al-p-4 al-rounded-lg al-gap-4 sm:al-flex-row sm:al-items-center"
          >
            <Stack direction="column" gap="xs" className="al-text-center sm:al-text-left">
              <Typography variant="section-heading" className="al-text-gray-900">
                Ready to automate your tasks?
              </Typography>
              <Typography size="sm" className="al-text-gray-600">
                Start building your AI teammates now
              </Typography>
            </Stack>
            <Button asChild size="lg" className="al-w-full sm:al-w-auto al-shrink-0">
              <Link to="/datamates">Go to Datamates</Link>
            </Button>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}

export { DatamatesSection };
